import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Spacing from "../Spacing";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/user/userSlice";
import { useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Header({ logoSrc, menuSrc, variant }) {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileToggle(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (
      user?.user?.active_plan &&
      user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
      user?.user?.active_plan?.payment_status === "SUCCESS"
    ) {
      // console.log("User has an active plan:", user.user.active_plan);
    }
  }, [user?.user?.active_plan]);

  const logout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  const handleEkinCare = () => {
    if (user?.user?.email) {
      window.open(
        `https://pricing.getafixmd.com/public/api/reg-ekincare/${user?.user?.token}`,
        "_blank"
      );
    } else {
      alert("Please update email first to access eKinCare");
    }
  };

  const handleCultFit = () => {
    window.open(
      `https://www.cult.fit`,
      "_blank"
    );
  };

  const secondAdultName =
    typeof user?.user?.family_detials === "object"
      ? user?.user?.family_detials?.secondAdult?.name
      : JSON.parse(user?.user?.family_detials || "{}")?.secondAdult?.name;

  return (
    <>
      <header
        style={{
          padding: "30px 0px"
        }}
        className={`cs_site_header cs_style1 cs_sticky_header ${mobileToggle ? "cs_mobile_toggle_active" : ""
          } ${variant} ${isSticky ? "cs_active_sticky" : ""}`}
      >
        <div className="cs_main_header_left" style={{ marginLeft: "auto", marginRight: "auto" }}>
          <Link
            className="cs_site_branding"
            to="https://getafixmd.com/"
            style={{ width: "148px", height: "auto", display: mobileToggle ? "none" : "block" }}
          >
            <img src={logoSrc} alt="Logo" style={{ width: "148px", height: "auto", }} />
          </Link>

          <div className="wid-100px" style={{ width: "100px" }}></div>
          <nav className="cs_nav">
            {user?.success && user?.user?.token ? (
              <>
                {mobileToggle ? (
                  <>
                    <span
                      className="cs_menu_toggle cs_teggle_active"
                      style={{ zIndex: "9999999999999999999999999999", top: '6vh' }}
                      onClick={() => setMobileToggle(false)}
                    >
                      <div className="vl-offcanvas-close d-block d-lg-none">
                        <button type="button" className="vl-offcanvas-close-toggle">
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                    </span>
                    <ul className="cs_nav_list cs_active" style={{ paddingTop: "80px" }}>
                      {user?.success && user?.user?.token && (
                        <li>
                          <Link className="cs_hero_btn_wrap" to="/profile">
                            <div
                              style={{
                                padding: "7px 20px",
                                borderRadius: "2rem",
                                fontWeight: "bold",
                                border: "1px solid #0e6ebe",
                                backgroundColor: "#0effbe",
                                color: "#0e6ebe",
                              }}
                            >
                              <span>Profile</span>
                            </div>
                          </Link>
                        </li>
                      )}

                      {user?.user?.active_plan &&
                        user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                        user?.user?.active_plan?.payment_status === "SUCCESS" && (
                          <li>
                            <a
                              // href={`https://getafixmd.howincloud.com/public/ekincare/authenticate/${user?.user?.token}`}
                              onClick={handleEkinCare}
                              style={{
                                backgroundColor: "#0effbe",
                                color: "#0e6ebe",
                                padding: "7px 20px",
                                borderRadius: "10pc",
                              }}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                Go to eKincare Dashboard
                              </span>
                            </a>
                          </li>
                        )}

                      {user?.user?.active_plan &&
                        user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                        user?.user?.active_plan?.payment_status === "SUCCESS" && (
                          <li>
                            <a
                              onClick={handleCultFit}
                              style={{
                                backgroundColor: "#0effbe",
                                color: "#0e6ebe",
                                padding: "7px 20px",
                                borderRadius: "10pc",
                              }}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                Go to Cult Fit - {(user?.user?.name).substring(0, 10)}
                              </span>
                            </a>
                          </li>
                        )}

                      {user?.user?.active_plan && secondAdultName &&
                        user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                        user?.user?.active_plan?.payment_status === "SUCCESS" && (
                          <li>
                            <a
                              onClick={handleCultFit}
                              style={{
                                backgroundColor: "#0effbe",
                                color: "#0e6ebe",
                                padding: "7px 20px",
                                borderRadius: "10pc",
                              }}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                Go to Cult Fit -&nbsp;
                                {(secondAdultName).substring(0, 10)}
                              </span>
                            </a>
                          </li>
                        )}

                      {user?.success && user?.user?.token && (
                        <li>
                          <a
                            className="cs_appointment_category"
                            style={{
                              backgroundColor: "#0effbe",
                              color: "#0e6ebe",
                              padding: "7px 20px",
                              borderRadius: "10pc",
                              border: "1px solid #0e6ebe",
                            }}
                            onClick={logout}
                          >
                            <span style={{ fontWeight: "bold" }}>Logout</span>
                          </a>
                        </li>
                      )}

                      {user?.success && user?.user?.token && (
                        <li>
                          <a
                            href="https://wa.me/919995159567"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ padding: "0px !important" }}
                          >
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "#0effbe",
                                padding: "0px !important",
                              }}
                            >
                              Talk to Us
                            </span>
                          </a>
                        </li>
                      )}
                    </ul>
                  </>
                ) : (
                  <ul className="cs_nav_list">
                    {user?.success && user?.user?.token && (
                      <li>
                        <Link className="cs_hero_btn_wrap" to="profile">
                          <div
                            style={{
                              padding: "7px 20px",
                              borderRadius: "2rem",
                              fontWeight: "bold",
                              border: "1px solid #0e6ebe",
                              backgroundColor: "#0effbe",
                              color: "#0e6ebe",
                            }}
                          >
                            <span>Profile</span>
                          </div>
                        </Link>
                      </li>
                    )}

                    {user?.user?.active_plan &&
                      user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                      user?.user?.active_plan?.payment_status === "SUCCESS" && (
                        <li>
                          <a
                            // href={`https://getafixmd.howincloud.com/public/ekincare/authenticate/${user?.user?.token}`}
                            onClick={handleEkinCare}
                            style={{
                              backgroundColor: "#0effbe",
                              color: "#0e6ebe",
                              padding: "7px 20px",
                              borderRadius: "10pc",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              Go to eKincare Dashboard
                            </span>
                          </a>
                        </li>
                      )}

                    {user?.user?.active_plan &&
                      user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                      user?.user?.active_plan?.payment_status === "SUCCESS" && (
                        <li>
                          <a
                            onClick={handleCultFit}
                            style={{
                              backgroundColor: "#0effbe",
                              color: "#0e6ebe",
                              padding: "7px 20px",
                              borderRadius: "10pc",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              Go to Cult Fit - {(user?.user?.name).substring(0, 10)}
                            </span>
                          </a>
                        </li>
                      )}

                    {user?.user?.active_plan && secondAdultName &&
                      user?.user?.active_plan !== "NOPLANSUBSCRIBED" &&
                      user?.user?.active_plan?.payment_status === "SUCCESS" && (
                        <li>
                          <a
                            onClick={handleCultFit}
                            style={{
                              backgroundColor: "#0effbe",
                              color: "#0e6ebe",
                              padding: "7px 20px",
                              borderRadius: "10pc",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              Go to Cult Fit -&nbsp;
                              {(secondAdultName).substring(0, 10)}
                            </span>
                          </a>
                        </li>
                      )}

                    {user?.success && user?.user?.token && (
                      <li>
                        <a
                          className="cs_appointment_category"
                          style={{
                            backgroundColor: "#0effbe",
                            color: "#0e6ebe",
                            padding: "7px 20px",
                            borderRadius: "10pc",
                            border: "1px solid #0e6ebe",
                          }}
                          onClick={logout}
                        >
                          <span style={{ fontWeight: "bold" }}>Logout</span>
                        </a>
                      </li>
                    )}

                    {user?.success && user?.user?.token && (
                      <li>
                        <a
                          href="https://wa.me/919995159567"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ padding: "0px !important" }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "#0effbe",
                              padding: "0px !important",
                            }}
                          >
                            Talk to Us
                          </span>
                        </a>
                      </li>
                    )}
                  </ul>
                )}
              </>
            ) : (
              <div
                className="cs_navigation"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "80px",
                }}
              >
                <div
                  className="cs_menu"
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {mobileToggle ? (
                    <>
                      <div style={{ width: "100vw", position: "fixed", top: "0px", left: "0px", padding: "50px 36px", height: "100vh", backgroundColor: "#0e6ebe" }}>
                        <div style={{ width: "90%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px" }}>
                          <img src="/images/logow.png" alt="Logo" style={{ width: "148px", height: "auto" }} />
                          <i
                            className="fa-solid fa-xmark"
                            onClick={() => setMobileToggle(false)}
                            style={{ cursor: "pointer", fontSize: "24px", zIndex: '99999999999999999999999999' }}
                          ></i>
                        </div>
                        <div>
                          <ul
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                              justifyContent: "start",
                              listStyle: "none",
                              gap: "20px",
                              margin: '8px 0px 30px 0px'
                            }}
                          >
                            <li>
                              <Link
                                to="https://getafixmd.com/"
                                className="nav-link2"
                                onClick={() => setMobileToggle(false)}
                              >
                                Home
                              </Link>
                            </li>
                            {!location?.pathname?.includes("/partner") && (
                              <>
                                <li>
                                  <Link
                                    to="https://getafixmd.com/medical-conditions.html"
                                    className="nav-link2"
                                    onClick={() => setMobileToggle(false)}
                                  >
                                    Medical Conditions
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/"
                                    className="nav-link2"
                                    onClick={() => setMobileToggle(false)}
                                  >
                                    Pricing
                                  </Link>
                                </li>
                              </>
                            )}
                            {/* {location?.pathname?.includes("/partner") ? (
                              <li>
                                <a
                                  className="nav-link2"
                                  href="#"
                                  // href="/public/sales-login"
                                  onClick={() => setMobileToggle(false)}
                                >
                                  Sales Partner Login
                                </a>
                              </li>
                            ) : (
                              <li>
                                <Link
                                  to="#"
                                  // to="https://getafixmd.com/partnerregistration"
                                  // target="_blank"
                                  className="nav-link2"
                                  onClick={() => setMobileToggle(false)}
                                >
                                  Sales Partner Registration
                                </Link>
                              </li>
                            )} */}
                            <li>
                              <Link
                                to="https://blogs.getafixmd.com/blogs/"
                                className="nav-link2 talk-to-us"
                                style={{ padding: "0px !important" }}
                                onClick={() => setMobileToggle(false)}
                              >
                                <a
                                  href="https://wa.me/919995159567?text=Hi%2C%20I%E2%80%99d%20like%20to%20know%20more"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ padding: "0px !important" }}
                                  className="talk-to-us"
                                >
                                  Talk to Us
                                </a>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="vl-offcanvas-social">
                          <div style={{ fontSize: '24px', color: '#fff', marginBottom: '20px', fontWeight: '500' }} className="vl-offcanvas-sm-title">Follow Us</div>
                          <a href="https://www.facebook.com/getafixmd/" target="_blank">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="https://x.com/GetAFixMD" target="_blank">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="https://www.linkedin.com/company/getafixmd/" target="_blank">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="https://www.instagram.com/getafixmd_healthcare/" target="_blank">
                            <i className="fab fa-instagram"></i>
                          </a>
                          <a href="https://www.youtube.com/@GetAFixMD_official/" target="_blank">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </div>
                      </div>
                    </>
                  ) : (
                    <ul
                      className="cs_nav_list"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0px",
                        padding: 0,
                        margin: 0,
                        listStyle: "none",
                        flexWrap: "nowrap",
                      }}
                    >
                      <li>
                        <Link to="https://getafixmd.com/" className="nav-link">
                          Home
                        </Link>
                      </li>
                      {!location?.pathname?.includes("/partner") && (
                        <>
                          <li>
                            <Link
                              to="https://getafixmd.com/medical-conditions.html"
                              className="nav-link"
                            >
                              Medical Conditions
                            </Link>
                          </li>
                          <li>
                            <Link to="/" className="nav-link">
                              Pricing
                            </Link>
                          </li>
                        </>
                      )}
                      {/* {location?.pathname?.includes("/partner") ? (
                        <li>
                          <a
                            href="#"
                            // href="/public/sales-login"
                            className="nav-link"
                          >
                            Sales Partner Login
                          </a>
                        </li>
                      ) : (
                        <li>
                          <Link
                            to="#"
                            //  to="https://getafixmd.com/partnerregistration"
                            className="nav-link"
                          //  target="_blank"
                          >
                            Sales Partner Registration
                          </Link>
                        </li>
                      )} */}
                      <li>
                        <Link
                          to="https://blogs.getafixmd.com/blogs/"
                          className="nav-link talk-to-us"
                          style={{ padding: "0px !important" }}
                        >
                          <a
                            href="https://wa.me/919995159567?text=Hi%2C%20I%E2%80%99d%20like%20to%20know%20more"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ padding: "0px !important" }}
                            className="nav-link talk-to-us"
                          >
                            Talk to Us
                          </a>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
            {mobileToggle ? (
              <span className="cs_menu_toggle cs_teggle_active" onClick={() => setMobileToggle(false)}>
                <div className="vl-offcanvas-close d-block d-lg-none">
                  <button type="button" className="vl-offcanvas-close-toggle">
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </span>
            ) : (
              <span className="cs_menu_toggle" onClick={() => setMobileToggle(true)}>
                <div className="vl-header-action-item d-block d-xl-none">
                  <button type="button" className="vl-offcanvas-toggle">
                    <i className="fa-solid fa-bars-staggered"></i>
                  </button>
                </div>
              </span>
            )}
          </nav>
          <div id="google_translate_element" style={{
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Nunito, sans-serif',
            backgroundColor: '#0effbe',
            color: '#0e6ebe',
            fontWeight: 'bold',
            border: '1px solid #0e6ebe',
          }}></div>
          {!user?.success && (
            <>
              <div
                className="cs_right_components"
                style={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "20px",
                }}
              >
                <ul
                  className="social-icons"
                  style={{
                    display: "flex",
                    gap: "30px",
                    alignItems: "center",
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <li>
                    <a href="https://www.facebook.com/getafixmd" target="_blank" style={{ color: "#0effbe" }}>
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/getafixmd" target="_blank" style={{ color: "#0effbe" }}>
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/getafixmd_healthcare" target="_blank" style={{ color: "#0effbe" }}>
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@GetAFixMD_official" target="_blank" style={{ color: "#0effbe" }}>
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/GetAFixMD" target="_blank" style={{ color: "#0effbe" }}>
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <Link onClick={() => setSideNav(!sideNav)} className="cst_menu">
                <img src={menuSrc} alt="menu" style={{ width: "50px" }} />
              </Link>
            </>
          )}
        </div>
      </header>
      <div className={`cs_sidenav ${sideNav ? "active" : ""}`}>
        <div
          className="cs_sidenav_overlay"
          onClick={() => setSideNav(!sideNav)}
        />
        <div className="cs_sidenav_in">
          <button
            className="cs_close"
            type="button"
            onClick={() => setSideNav(!sideNav)}
          >
            <img src="/images/icons/close.svg" alt="Close" />
          </button>
          <Spacing md="35" lg="35" xl="35" />
          <Link to="https://getafixmd.com/" onClick={() => setSideNav(false)}>
            <div className="menu-item">Home</div>
          </Link>
          <Link onClick={() => {
            setSideNav(false);
            setMobileToggle(false);
          }}>
            <div className="menu-active">Pricing</div>
          </Link>
          <Link to="https://getafixmd.com/medical-conditions.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Medical Conditions</div>
          </Link>
          <Link to="https://getafixmd.com/nebula.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Nebula</div>
          </Link>
          <Link to="https://getafixmd.com/terms-conditions.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Terms and Conditions</div>
          </Link>
          <Link to="https://getafixmd.com/privacy-policy.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Privacy Policy</div>
          </Link>
          <Link to="https://getafixmd.com/contact-us.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Contact Us</div>
          </Link>
          <Link to="https://getafixmd.com/commonly-faq.html" onClick={() => setSideNav(false)}>
            <div className="menu-item">Commonly Asked Questions</div>
          </Link>

          <div
            style={{ marginTop: "50px" }}
            className="d-flex align-items-center justify-content-between"
          >
            <div style={{ color: "#fff", fontSize: "25px", fontWeight: "600" }}>
              <Icon icon="bi:envelope" />
              <span style={{ marginLeft: "5px" }}>info@getafixmd.com</span>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
}